module.exports = __webpack_public_path__ + "71b4fefc2af19e83245a2cc6686c5b28.pdf";